import { render, staticRenderFns } from "./user-submissions.view.vue?vue&type=template&id=646ac338&scoped=true&"
import script from "./user-submissions.view.vue?vue&type=script&lang=ts&"
export * from "./user-submissions.view.vue?vue&type=script&lang=ts&"
import style0 from "./user-submissions.view.vue?vue&type=style&index=0&id=646ac338&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "646ac338",
  null
  
)

export default component.exports